import { ApiUtility } from "../Utilities/ApiUtility.axios";

class BkGeneralSettingsAdminService {
    route = `/API/GeneralSettings`;

    getAllAdvisoryRate = () => ApiUtility.get(`${this.route}/AdvisoryRate/All`);
    getAdvisoryRate = (date: any) => ApiUtility.get(`${this.route}/AdvisoryRate?date=${date}`);
    getStandardRate = () => ApiUtility.get(`${this.route}/StandardRate`);
    postGeneralSettings = (params?: any) => ApiUtility.post(`${this.route}`, params);
    updateSingleAdvisoryRate = (params?: any) => ApiUtility.post(`${this.route}/updateSingleAdvisoryRate`, params);
}

export default new BkGeneralSettingsAdminService();
